import React from 'react';
import { sortArray, USER_SUBSCRIPTION_STATUS } from 'utils';

const UserSubscriptionStatusDropdown = props => {
  const {
    value,
    onChange,
    disabled,
  } = props;

  const getOptions = () => sortArray(Object.keys(USER_SUBSCRIPTION_STATUS)).map((status, i) => (
    <option key={i} value={USER_SUBSCRIPTION_STATUS[status]}>
      {status}
    </option>
  ));
  
  return (
    <select
      value={value}
      disabled={disabled}
      className={'form-control'}
      onChange={e => onChange(e.target.value)}
    >
      <option value='none' hidden={!!value}>Choose Status</option>
      {getOptions()}
    </select>
  );
};

export default UserSubscriptionStatusDropdown;
